<template>
  <div class="home">
    <div class="content-wrapper">
      <MainMenu />
      <div class="content">

        <div class="vertical-container">
          <div class="container">
            <div class="left">


              <h3>Patříme k nejstarším vědeckým společnostem o živé přírodě u nás</h3>

              <p class="text">Naším cílem a posláním je sdružovat všechny zájemce o zoologii, a to nejen z řad vědeckých pracovníků a
                pedagogů, ale také studentů či širší veřejnosti, kteří se chtějí podílet na rozvoji a popularizaci
                zoologie.</p>

              <p  class="text">Česká zoologická společnost má téměř stoletou tradici a během svého působení vybudovala rozsáhlou
                zoologickou knihovnu a po mnoho let vydává odborný časopis Acta Societatis Zoologicae Bohemicae. Nyní
                formujeme nové vize a připravujeme nové projekty, včetně aktualizace a modernizace webových stránek, na
                kterých stále pracujeme. Přihláška do Společnosti má nyní elektronickou podobu a lze vyplnit online,
                brzy se také můžete těšit například na online podobu a archív našeho časopisu. </p>

                <router-link :to='"/registrace"'>
              <picture>
                <source class="banner-clen" srcset="../assets/veverka.webp" type="image/webp">
                <img class="banner-clen" src="../assets/veverka.jpg" alt="Image">
              </picture>
            </router-link>

            </div>
          </div>
          <div class="article-wrapper">
            <h3>Aktuality</h3>

                    <div class="article">
              <div class="article-content">
                <h4>Časopis Acta Societatis Zoologicae Bohemicae opět online</h4>
                <p>Odborný časopis České zoologické společnosti, Acta Societatis Zoologicae Bohemicae (ASZB), je po krátké technické odmlce opět plně dostupný online. Všechny příspěvky naleznete na nových webových stránkách. Odborný časopis ASZB, který naše Společnost vydává již od roku 1927, je recenzovaný open access časopis. Publikuje původní výzkumné články zaměřené na obecnou zoologii, aplikovanou zoologii a systematickou zoologii, a dále také biografie. Věříme, že obnovení online platformy usnadní čtenářům přístup k obsahu a zveme autory k zasílání svých rukopisů.</p>
                <a href="https://aszb.cz" target="_blank">Webové stránky aszb.cz</a>
              </div>
            </div>

        <div class="article">
              <div class="article-content">
                <h4>Překvapivé rozšíření gibonů v Laosu</h4>
                <p>Gibon bělolící (Nomascus leucogenys) a siki (Nomascus siki) jsou endemity Laosu a Vietnamu. Studie, která analyzovala 90 giboních písní z přírody a 32 nahrávek z evropských zoologických zahrad, zpochybňuje dosavadní předpoklad, že řeka Nam Theun-Nam Kading tvoří přirozenou bariéru mezi těmito dvěma druhy. Akustickou analýzou giboních písní, které jsou druhově specifické, bylo zjištěno, že oba druhy se vyskytují na obou stranách řeky Nam Theun-Nam Kading v Národním parku Nakai-Nam Theun a okolních oblastech. Klasifikační analýza založená na strojovém učení (Random Forest) dosáhla vysoké přesnosti: 97 % u samců a 89 % u samic. Tato nová zjištění mají zásadní význam pro plánování potenciálních reintrodukčních programů či translokací těchto ohrožených druhů v regionu a je potřeba je brát v úvahu při navrhování strategií ochrany těchto jedinečných primátů.</p>
                <a href="https://link.springer.com/article/10.1007/s10764-025-00491-5?fbclid=IwY2xjawJQ7XBleHRuA2FlbQIxMAABHQhzPo8z-ZA46B5uVyzQkbuYZX70-nhpt8yzgWRgMzl7IrOrGJj6hKjIcg_aem_TIn-O3QWpj-F_fuH1gzZjg" target="_blank">Odkaz na studii</a>
              </div>
              <img :src="require('@/assets/events/event_6.jpg')" alt="preview">
            </div>

            <div class="article">
              <div class="article-content">
                <h4>Výsledky studentské soutěže v rámci konference Zoologické dny 2025</h4>
                <h5>Nejlepší studentská přednáška</h5>

                <ul>
                  <li>
                    <strong>1. místo</strong> – Ondřej Vaněk (Přírodovědecká
                    fakulta UK, Praha): Nový? Přehlížený? Je zde! Aneb příspěvek
                    (nejen) k rozšíření vzokana Thalerova (Cortestina thaleri)
                  </li>
                  <li>
                    <strong>2. místo</strong> – Agáta Horáčková (Přírodovědecká
                    fakulta UK, Praha), Černý R.: Bichiři, jeseteři a kostlíni
                    jako živoucí fosílie osvětlující vznik hlavy obratlovců
                  </li>
                  <li>
                    <strong>3. místo</strong> – Dominik Pliska (Ústav botaniky a
                    zoologie PřF MU, Brno), Sychra J., Bojková J., Janáč M.:
                    Rybí predace jako klíčový faktor formující společenstva
                    zooplanktonu nových tůní
                  </li>
                </ul>

                <h5>Nejlepší studentský poster</h5>

                <ul>
                  <li>
                    <strong>1. místo</strong> – Jasna Simonová (Přírodovědecká
                    fakulta UK, Praha), Kadlecová B., Simon-Pražák J., Dronská
                    V., Peyerl K., Juřičková L.: Jak létají šneci?
                    Experimentální pohled na ektozoochorii plžů s využitím
                    závodních holubů
                  </li>
                  <li>
                    <strong>2. místo</strong> – Klára Foltýnová (Pedagogická
                    fakulta MU, Brno), Frýzová I., Smolinský R.: Školní zahrada
                    jako edukační prostředí pro zoologii obratlovců
                  </li>
                  <li>
                    <strong>3. místo</strong> – Adam Mikunda (Přírodovědecká
                    fakulta, OU, Ostrava), Ožana S., Pyszko P., Prieložná V.,
                    Plášek V.: Nepoznané ostrovy biodiverzity: opomíjená městská
                    zeleň jako neočekávaný habitat mnoha vzácných a pro ČR
                    nových druhů členovců
                  </li>
                </ul>
<!--                 <a v-if="article.article_url != null" :href="article.article_url" target="_blank">{{
                  article.article_desc }}</a> -->
              </div>
              <img :src="require('@/assets/events/event_5.jpg')" alt="preview">
            </div>

            <div class="article">
              <div class="article-content">
                <h4>O zpěvu gibonů v aktuálním čísle časopisu Živa</h4>
                <p>Ačkoliv jsou giboni jedinou skupinou lidoopů, která produkuje melodické a komplexní zpěvy, které samec a samice žijící v páru kombinují do koordinovaných duetů, je o vývoji této vokalizace zatím známo velice málo. Tomuto tématu se dlouhodobě věnuje Michal Hradec s kolegy z Fakulty agrobiologie, potravinových a přírodních zdrojů České zemědělské univerzity v Praze. Jeho článek publikovaný v letos prvním čísle časopisu Živa shrnuje výsledky výzkumů provedených v zoologických zahradách a zaměřených na prozkoumání vývoje této vokalizace u samců gibona zlatolícího (Nomascus gabriellae).</p>
<!--                 <a v-if="article.article_url != null" :href="article.article_url" target="_blank">{{
                  article.article_desc }}</a> -->
              </div>
              <img :src="require('@/assets/events/ziva_2025.jpg')" alt="preview">
            </div>

            <div v-for="article in this.articles" :key="article.id" class="article">
              <div class="article-content">
                <h4>{{ article.preview_title }}</h4>
                <p v-html="article.preview_description"></p>
                <a v-if="article.article_url != null" :href="article.article_url" target="_blank">{{
                  article.article_desc }}</a>
              </div>
              <img v-if="article.image_url != null" :src="article.image_url" alt="preview">
            </div>
          </div>
        </div>
      </div>
      <FooterMenu />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

import useAuth from "../use-auth";
import useLogin from "../use-login";

import MainMenu from '../components/ui/MainMenu.vue';
import FooterMenu from '../components/ui/FooterMenu.vue';

export default {
  name: 'HomeView',
  components: {
    MainMenu, FooterMenu
  },
  data() {
    return {
      articles: [
        {
          "id": 5,
          "preview_title": "Zoologické dny Brno 2025",
          "preview_description": "Pravidelné setkání zoologů z České republiky a Slovenska pořádané pod záštitou Ústavu biologie obratlovců AV ČR, Ústavu botaniky a zoologie Přírodovědecké fakulty MU v Brně a Českou zoologickou společností se letos uskuteční 13. a 14. února v Brně v prostorách Ekonomicko-správní fakulty MU. Na programu je téměř 150 přednášek včetně dvou plenárních a téměř 160 posterů. Součástí programu je též společenský banket a soutěž o nejlépe hodnocenou studentskou přednášku a poster.",
          "image_url": require('@/assets/events/event_5.jpg'),
          "article_url": "https://www.ivb.cz/vyzkum/zoologicke-dny/",
          "article_desc": "Více na oficiálních stránkách",
          "createdAt": "2025-02-12T00:09:58.416Z",
          "updatedAt": "2025-02-12T00:09:58.416Z"
        },
        {
          "id": 4,
          "preview_title": "Česká společnost entomologická vás zve na Výměnný den ČSE",
          "preview_description": "Česká společnost entomologická zve všechny entomology, sběratele hmyzu a zájemce o hmyz na na Výměnný den ČSE, který se koná 15. února v KD Barikádníků v Praze. Na této akci je možné vidět i pořídit řadu zajímavých exemplářů hmyzu včetně hmyzu terarijního, entomologické pomůcky, literaturu i setkat se s kolegy k entomologickým diskuzím. Je zde také možné podat přihlášku do ČSE, vyřešit členské záležitosti nebo vyzvednout časopisy ČSE. Po akci proběhnou i entomologicky zaměřené přednášky pro členy i veřejnost. ",
          "image_url": null,
          "article_url": null,
          "createdAt": "2025-02-12T00:06:25.870Z",
          "updatedAt": "2025-02-12T00:06:25.870Z"
        },
        {
          "id": 3,
          "preview_title": "O damanech v aktuálním čísle časopisu Vesmír",
          "preview_description": "Vloni přibližně touto dobou vyšla v časopise \u003Ca href=\"https://www.jzar.org/jzar/article/view/735\"\u003EJournal of Zoo and Aquarium Research (JZAR)\u003C/a\u003E vydávaném Evropskou asociací zoologických zahrad a akvárií (EAZA) studie o stromových damanech žijících v zoologických zahradách. Ta ukázala, že damani žijící v některých evropských zoo, původně určení jako daman stromový (Dendrohyrax arboreus), pravděpodobně nejsou zástupci tohoto druhu.  Analýza jejich hlasových projevů ukázala, že mají mnohem více společného s populací damanů žijící v jižní Keni, která byla objevena teprve v roce 2020.",
          "image_url": require('@/assets/events/event_2.jpg'),
          "article_url": "https://vesmir.cz/cz/casopis/archiv-casopisu/2025/cislo-2/tak-se-z-lesa-ozyva.html",
          "article_desc": "Článek v aktuálním čísle časopisu Vesmír",
          "createdAt": "2025-02-11T23:57:08.744Z",
          "updatedAt": "2025-02-11T23:57:08.744Z"
        },
        {
          "id": 2,
          "preview_title": "Hadí pohlavní chromozomy jsou pestřejší, než jsme si mysleli",
          "preview_description": "Po desítky let se věřilo, že všichni hadi mají stejné ZZ/ZW pohlavní chromozomy. Toto platí pro většinu hadů, konkrétně pro skupinu Caenophidia, která zahrnuje více než 80 % známých druhů. Nová studie publikovaná v odborném časopise Molecular Biology and Evolution, vedená týmem z Přírodovědecké fakulty Univerzity Karlovy, však odhalila něco nečekaného! Ukázalo se, že hadi mimo tuto skupinu vykazují překvapivou variabilitu v systému určení pohlaví. Autoři studie identifikovali pohlavní chromozomy u anakond, madagaskarských hroznýšů, hroznýšků, hroznýšovců, slepáků a dalších druhů. Dnes víme, že hadi mají nejméně sedm různých typů určení pohlaví, včetně nezávisle vzniklých chromosomových systémů typu XX/XY i ZZ/ZW.",
          "image_url": require('@/assets/events/event_3.jpg'),
          "article_url": "https://academic.oup.com/mbe/article/42/1/msae255/7923268?fbclid=IwZXh0bgNhZW0CMTAAAR22TK_-yaDEE8gANXtypbtM524vmpdxKriO5V4rBYa0TmhoRri5K5t0NLQ_aem_-9pLq7E9IywfZ1Mkm5dWEA",
          "article_desc": "Odkaz na studii",
          "createdAt": "2025-02-11T23:48:28.907Z",
          "updatedAt": "2025-02-11T23:48:28.907Z"
        },
        {
          "id": 1,
          "preview_title": "Změny na sekretariátu",
          "preview_description": "Od 1. ledna 2025 dochází ke změně na pozici sekretářky České zoologické společnosti. Nově tuto funkci zastupuje Bc. Lucie Macková a dochází také ke změně kontaktního e-mailu. Chcete-li nás kontaktovat, pište na \u003Ca href=\"mailto:info@zoospol.cz\"\u003Einfo@zoospol.cz\u003C/a\u003E. ",
          "image_url": null,
          "article_url": null,
          "createdAt": "2025-02-11T23:33:15.655Z",
          "updatedAt": "2025-02-11T23:33:15.655Z"
        }
      ]
    };
  },
  setup() {
    let { user, loading, error } = useAuth();
    let loginState = useLogin();

    return {
      user,
      loading,
      error: computed(() => (loginState.error || error).value),
      logout: loginState.logout
    };
  }
}
</script>

<style scoped>
.container {
  display: flex;


}

.vertical-container {
  display: flex;
  flex-direction: column;
  width: 1000px;
  margin: 0px auto;
}

h1 {
  font-weight: bolder;
  font-size: 2em;
}

h2 {
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 20px;
}

.banner-clen {
  width: 100%;
}

p {
  font-size: 14px;
  font-weight: 400;
  margin: 0px 25px 25px 0px;
  line-height: 1.2;
  text-align: justify;
}

h3 {
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 20px;
  color: #323232;
  margin-right: 25px;
  margin-left: 25px;
}

h4 {
  margin-top: 10px;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 20px;
  color: #323232;
  margin-right: 25px;
}


.text {
  color: #323232;
  font-size: 14px;
  font-weight: 400;
  margin: 25px 25px 25px 25px;
  line-height: 1.2;
}

picture {
display: block;
margin: 20px;
}

.ellipsis {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.left { }

.right {
  min-width: 300px;
}

.article-wrapper {
  margin-top: 25px;
}

.article {
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: white;
  margin-bottom: 15px;
  padding: 10px;
}

.article img {
  max-height: 200px;
  width: 200px;
  object-fit: contain;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.article-content {
  flex: 1;
  margin-left: 10px;
  padding-bottom: 10px;
}

.article-content h3 {
  font-weight: bold;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #323232;
}

.article-content a {
  color: #2f6508;
  text-decoration: underline dotted;
  text-underline-offset: 3px;
  cursor: pointer;

}

.article-content>>>a {
  color: #2f6508;
  text-decoration: underline dotted;
  text-underline-offset: 3px;
  cursor: pointer;
}

.article-content>>>p {
  font-size: 14px;
  text-align: left;
  color: #323232;
}

li {
  font-size: 14px;
  line-height: 1.2em;
  color: #323232;
}

strong {
  font-weight: bold;
  color: #323232;
}

h5 {
  font-size: 14px;
  font-weight: 500;
  color: #323232;
}



@media (max-width: 1000px) {

  .container {
    width: 100%;
    flex-direction: column;
  }

  .article {
    margin-bottom: 15px;

    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .vertical-container {
    width: 100%;
  }

  h2 {
    margin-left: 25px;
  }


}
</style>
